export function usarFuncoesStrings() {
  const retirarCaracteresEspeciais = (palavra: string[]): string[] =>
    palavra.map((letra: string) => letra.replace(/[^a-zA-Z0-9]/g, ''))

  const separarNomePorEspaco = (nomeParaSeparar: string): string[] =>
    nomeParaSeparar.trim().split(" ")

  const filtrarNome = (listaDePartesDoNome: string[]): string[] => {
    listaDePartesDoNome = retirarCaracteresEspeciais(listaDePartesDoNome)
    return [...listaDePartesDoNome].filter(
      (nome) => !/^((de)|(do)|(da)|(dos)|(das))$/i.test(nome)
    )
  }

  const retornarIniciais = (listaDePartesDoNome: string[]): string => {
    const apenasNomeComSobrenome = listaDePartesDoNome.slice(0, 2)
    const listaDeIniciais = apenasNomeComSobrenome.map((nome) => nome[0])
    return listaDeIniciais.join("")
  }

  const tornarIniciaisMaiusculas = (iniciaisDoNome: string): string =>
    iniciaisDoNome.toUpperCase()

  const pegarIniciais = (nome: string) =>
    tornarIniciaisMaiusculas(
      retornarIniciais(filtrarNome(separarNomePorEspaco(nome)))
    )

  return {
    pegarIniciais,
    filtrarNome,
    retirarCaracteresEspeciais
  }
}
